<script lang="ts" setup>
withDefaults(
  defineProps<{ icon: string; text: string; disabled?: boolean }>(),
  {
    disabled: false,
  },
);
</script>

<template>
  <a-button
    :disabled="disabled"
    type="text"
    size="small"
    class="flex-center !flex !rounded-md !px-0 hover:!text-inherit"
    ><img class="mr-1 w-4" :src="icon" alt="" />{{ text }}</a-button
  >
</template>
<style scoped>
:disabled {
  @apply !text-colorTextQuaternary opacity-70;
}
:disabled img {
  @apply !opacity-50;
}
</style>
